const Preloader = () => {
  return (
    <>
      <div className="preloader">
        <img src="assets/images/icon/preloader.gif" alt="" />
      </div>
    </>
  );
};

export default Preloader;
